<template>
    <div class="card-produto-informacao">
      <g-card :temCabecalho="false" :expansivel="false">
        <div class="header-detalhes-secundario">
          <div class="header-detalhes-secundario-titulo">
            <g-button
            lass="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
            />
            <div class="titulo-detalhes-cabecalho">Detalhes</div>
          </div>
        </div>

        <div class="espacamento-detalhes">
            <div class="titulo-grupo-detalhes">Dados do Produto</div>
            <div class="dados-grupo">

              <div class="dados-pedido-parcela">
                <div class="titulo-conteudo-detalhes">Pedido / Parcela</div>
                <div class="label-conteudo">{{codigoPedido}} / {{numeroParcela}}</div>
              </div>

              <div class="dados-produto">
                <div class="titulo-conteudo-detalhes">Produto</div>
                <div class="label-conteudo">{{codigoProduto}} - {{nomeProduto || 'Não Possui'}}</div>
              </div>

              <div class="dados-cliente">
                <div class="titulo-conteudo-detalhes">Cliente</div>
                <div class="label-conteudo">{{codigoExterno}} - {{nome}}</div>
              </div>

              <div class="dados-cv">
                <div class="titulo-conteudo-detalhes">CV</div>
                <div class="label-conteudo">{{curvaClienteDesc || 'Não Possui'}}</div>
              </div>

              <div class="dados-liquidados">
                <div class="titulo-conteudo-detalhes">Liquidado</div>
                <div class="label-conteudo">{{liquidado || "Não"}}</div>
              </div>

              <div class="dados-caixas">
                <div class="titulo-conteudo-detalhes">Qtde Caixas</div>
                <div class="label-conteudo">{{quantidadeCaixas}}</div>
              </div>

              <div class="dados-folhas">
                <div class="titulo-conteudo-detalhes">Qtde Folhas</div>
                <div class="label-conteudo">{{quantidadeFolhas}}</div>
              </div>

              <div class="dados-saldo">
                <div class="titulo-conteudo-detalhes">Saldo</div>
                <div class="label-conteudo">{{quantidadeSaldo}}</div>
              </div>

              <div class="dados-valor">
                <div class="titulo-conteudo-detalhes">Valor</div>
                <div class="label-conteudo">{{valorUnitarioCaixaFormatado}}</div>
              </div>

              <div class="dados-pedido">
                <div class="titulo-conteudo-detalhes">Qtde Pedido</div>
                <div class="label-conteudo">{{quantidadePedido}}</div>
              </div>

              <div class="dados-qtde-fatura">
                <div class="titulo-conteudo-detalhes">Qtde Fatur.Antecipado</div>
                <div class="label-conteudo">{{quantidadeFaturamentoAntecipado}}</div>
              </div>

              <div class="dados-valor-fatura">
                <div class="titulo-conteudo-detalhes">Valor Fatur.Antecipado</div>
                <div class="label-conteudo">{{valorFaturamentoAntecipado}}</div>
              </div>

              <div class="dados-data-entrega">
                <div class="titulo-conteudo-detalhes">Data da Entrega</div>
                <div class="label-conteudo">{{dataEntregaFormatada}}</div>
              </div>

              <div class="dados-data-carregamento">
                <div class="titulo-conteudo-detalhes">Data do Carregamento</div>
                <div class="label-conteudo">{{dataCarregamentoFormatada}}</div>
              </div>

              <div class="dados-data-estoque">
                <div class="titulo-conteudo-detalhes">Data do Estoque</div>
                <div class="label-conteudo">{{dataEstoqueFormatada}}</div>
              </div>

              <div class="dados-componentes">
                <div class="titulo-conteudo-detalhes">Componente</div>
                <div class="label-conteudo">{{ componenteTipoTexto }}</div>
              </div>

              <div class="daos-qtde-produzida">
                <div class="titulo-conteudo-detalhes">Qtde Produzida</div>
                <div class="label-conteudo">{{quantidadeProduzida}}</div>
              </div>

              <div class="dados-qtde-sobras">
                <div class="titulo-conteudo-detalhes">Qtde Sobras</div>
                <div class="label-conteudo">{{quantidadeSobras}}</div>
              </div>
            </div>  

            <div class="titulo-grupo-detalhes">Valores Totais</div>
            <div class="valores-totais-agrupados">
            <div class="titulo-conteudo">
            <div class="total-pedido titulo">Total deste Pedido / Parcela</div>
            <div class="valores-totais-titulo">

              <div class="valores-caixas">
                <div class="titulo-conteudo-detalhes">Caixas (UN)</div>
                <div class="label-conteudo">{{quantidadeCaixas}}</div>
              </div>

              <div class="valores-folhas">
                <div class="titulo-conteudo-detalhes">Folhas (UN)</div>
                <div class="label-conteudo">{{quantidadeFolhas}}</div>
              </div>

              <div class="valores-total">
                <div class="titulo-conteudo-detalhes">Total (R$)</div>
                <div class="label-conteudo">{{TotalPedidoParcela}}</div>
              </div>
          </div>
          </div>

              <div class="titulo-conteudo">
              <div class="total-produto titulo-conteudo-detalhes">Total Geral do Produto</div>
              <div class="valores-totais-titulo">

              <div class="valores-caixas">
                <div class="titulo-conteudo-detalhes">Caixas (UN)</div>
                <div class="label-conteudo">{{quantidadeCaixasTotal}}</div>
              </div>

              <div class="valores-folhas">
                <div class="titulo-conteudo-detalhes">Folhas (UN)</div>
                <div class="label-conteudo">{{quantidadeFolhasTotal}}</div>
              </div>

              <div class="valores-total">
                <div class="titulo-conteudo-detalhes">Total (R$)</div>
                <div class="label-conteudo">{{TotalPedido}}</div>
              </div>
          </div>
          </div>
          </div>
        </div>
      </g-card>
    </div>
  </template>

  <script>
  import ProdutosInformacao from "./ProdutosInformacao.js";
  export default ProdutosInformacao;
  </script>

  <style scoped>
  .card-produto-informacao{
    padding: 10px;
  }

  .titulo {
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 700;
    margin-top: 15px;
    color: #4F2C19;
    white-space: nowrap;
  }


  @media (min-width: 310px) {
    .valores-totais-titulo{
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 10%;
    display: grid;
    }
  }

  @media (min-width: 368px) {}

  @media (min-width: 600px) {
    .dados-grupo{
      display: grid;
      grid-template-columns: repeat(2, minmax(4em, 1fr));
      column-gap: 3%;}

    .infos-componentes{
      display: grid;
      grid-template-columns: repeat(3, minmax(4em, 1fr));}

    .valores-totais-titulo{
      display: grid;
      grid-template-columns: repeat(3, minmax(4em, 1fr));}
      
  }

  @media (min-width: 801px) {}

  @media (min-width: 1025px) { 
    .dados-grupo{grid-template-columns: repeat(3, minmax(4em, 1fr));}
    .infos-componentes{grid-template-columns: repeat(4, minmax(4em, 1fr));}
    .valores-totais-titulo{grid-template-columns: repeat(4, minmax(4em, 1fr));}
  }


  @media (min-width: 1281px) {
    .dados-grupo{grid-template-columns: repeat(5, minmax(4em, 1fr));}
    .infos-componentes{grid-template-columns: repeat(5, minmax(4em, 1fr));}
    .valores-totais-titulo{grid-template-columns: repeat(5, minmax(4em, 1fr));}
  }

  @media (min-width: 1500px) {}

  </style>